export class DropDownList {
    id: string;
    itemName: string;
    group?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/DropDownList.model.ts